/**
 * @desc 物流报价方案-报价信息更新
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsQuotationInfoUpdateDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/quotationInfo/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
